<div class="container">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
    </div>
    <h1>Subscriptions</h1>
    <table class="table table-striped">
        <thead class="txtbold">
            <tr>
                <th>Bedrijf</th>
                <th class="txtright">Aantal</th>
                <th class="txtright">Prijs</th>
                <th class="txtright">Totaal</th>
                <th>Opmerking</th>
                <th class="txtright">Laatst gefactureerd</th>
                <th class="txtright">Herhaal frequentie</th>
            </tr>
        </thead>
        <tbody>
            @for (subscription of companySubscriptions(); track subscription.id) {
                <tr [routerLink]="['/',Routenames.subscriptions,subscription.id]" class="curpoint">
                    <td>{{subscription.company?.name}}</td>
                    <td class="txtright">
                        @if (subscription.count_url?.length) {
                            <i>O: </i>
                        }
                        {{subscription.count}}
                    </td>
                    <td class="txtright">
                        {{subscription.price | currency : 'EUR'}}
                    </td>
                    <td class="txtright">
                        {{(subscription.count * subscription.price) | currency : 'EUR'}}
                    </td>
                    <td>
                        {{subscription.description}}
                    </td>
                    <td class="txtright">{{subscription.last_date | date : 'EEEE d MMM yyyy'}}</td>
                    <td class="txtright">{{subscription.repeat}}</td>
                </tr>
            }
            <tr class="txtbold">
                <td colspan="2">Totals</td>
                <td class="txtright">&euro; {{utils.sumProps(companySubscriptions(), 'price')}}</td>
                <td colspan="99"></td>
            </tr>
        </tbody>
    </table>

    <div>
        <button class="w-100 btn btn-primary" routerLink="/{{Routenames.subscriptions}}/new">
            Abonnement toevoegen <i class="fas fa-plus"></i>
        </button>
    </div>
</div>
